import { useQuery } from '@hooks/reactQuery';

import { map } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getPolygonsSummary } from '@api/map';

import { getAssetFiltersDto } from '@utils/getAssetTypesDtoForFilter';

import { IPolygonSummaryReturnType } from '@interfaces/map/polygon';

import { EDataType } from '@enums/map';

import { BOROUGHS } from '@constants/queryKeys';

export const useQueryPolygonsSummaryForAssets = (): {
	isLoadingPolygonsSummary: boolean;
	polygonsSummary?: IPolygonSummaryReturnType;
} => {
	const mapState = useAppSelector(map);

	const {
		activeBoroughs,
		activeCustomPolygons,
		appliedAssetsFilterValues,
		markerType,
		isAcquiredAssetsShownApplied,
		appliedAcquiredAssetsTypeFilter,
	} = mapState;

	const { data: polygonsSummary, isLoading, isFetching } = useQuery({
		queryKey: [
			BOROUGHS,
			activeBoroughs,
			activeCustomPolygons,
			appliedAssetsFilterValues,
			appliedAcquiredAssetsTypeFilter,
			isAcquiredAssetsShownApplied,
		],
		queryFn: () => getPolygonsSummary(getAssetFiltersDto(mapState)),
		refetchOnWindowFocus: false,
		enabled: [!!activeBoroughs.length || !!activeCustomPolygons.length, markerType === EDataType.assets],
	});

	return {
		polygonsSummary,
		isLoadingPolygonsSummary: isLoading && isFetching,
	};
};
